<template>
  <el-dialog
    v-if="visible"
    show-close
    :visible="visible"
    width="500px"
    :title="title"
    :close-on-click-modal="false"
    :before-close="() => close()"
    append-to-body
    v-el-dialog-drag
  >
    <el-form ref="form" :model="formData" size="small" :rules="rules">
      <el-row :gutter="20">
        <el-col :span="24">
          <el-form-item :label="$l('form_label_biz_person') || '工厂跟单人员'" prop="bizPersonCode">
            <dict-select
              clearable
              v-model="formData.bizPersonCode"
              filterable
              size="small"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.bizPersonName"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="close">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>

      <el-button size="small" type="primary" @click="batchUpdate">
        {{ $l('form_label_person_batch_updates') || '更新' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import validate from '@/libs/util.validate'

export default {
  mixins: [EditLoading],
  props: {
    visible: { type: Boolean, default: false },
    title: { type: String, default: '指派工厂跟单人员' },
  },
  data() {
    return {
      formData: {},
      rules: {
        bizPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },

  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    async batchUpdate() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) {
        return
      }
      this.$emit('confirm', this.formData)
    },
  },
}
</script>
<style lang="scss" scoped>
.side_frame_warning {
  border-left: 4px solid #fe6c6f;
  margin: 15px 0;
  border-radius: 4px;
}
.side_frame_pri {
  border-left: 4px solid #50bfff;
  margin: 15px 0;
  border-radius: 4px;
}
::v-deep .el-card__header {
  padding: 8px 8px;
  border-bottom: 0px;
}
::v-deep .el-card__body {
  padding: 10px;
}

.span_text_header {
  font-weight: 700;
  font-size: 18px;
}
.span_text_body {
  font-weight: 700;
  font-size: 15px;
}
</style>
